import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import style from './ChatBot.module.css';
import HeadSub from '../../../components/comm/HeadSub';
import imgAvata from '../../../images/common/img_chat_mascot.svg';
import iconAttach from '../../../images/common/i_chat_attach.svg';
import iconVoice from '../../../images/common/i_chat_voice.svg';


const DIET_EXERCISE_CHIPS = ['달리기', '걷기', '수영', '요가', '스트레칭', '자전거타기', '축구', '농구', '줄넘기', '스쿼트', '하이킹', '실내자전거', '알아서추천해줘'];

const QUICK_REPLIES = ['좋아요!', '다른운동', '장비없이', '실내로', '왜 이거야?', '더 쉬운걸로'];



const ExerciseChatBot = () => {
    const { state } = useLocation();
    const mode = state?.mode === 'exercise' ? 'exercise' : 'diet';

    const [isInputFocused, setIsInputFocused] = useState(false);
    const isAndroid = /Android/i.test(navigator.userAgent);

    const inputRef = useRef(null);
    const chatEndRef = useRef(null);
    const [textQuestion, setTextQuestion] = useState('');
    const [chatList, setChatList] = useState([]);
    const isInit = useRef(false);

    const [isSending, setIsSending] = useState(false);   // 채팅 입력 보냄
    const [showQuick, setShowQuick] = useState(true);    // 추천 리스트

    const handleQuickReply = (text) => {
        if (isSending) return;

        setChatList(prev => [
            ...prev,
            { type: 'user', text, chatTime: getCurrentTime() },
        ]);
    };

    // 날짜 유틸
    const getCurrentDateStr = () => {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        const d = String(now.getDate()).padStart(2, '0');
        const days = ['일', '월', '화', '수', '목', '금', '토'];
        return `${y}.${m}.${d}(${days[now.getDay()]})`;
    };
    const getCurrentTime = () => new Date().toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });

    
    useEffect(() => {
        if (isInit.current) return;
        isInit.current = true;

        const time = getCurrentTime();
        const dateLine = { type: 'date', dateStr: getCurrentDateStr() };

        setChatList([
            dateLine,
            { type: 'bot', text: '안녕하세요! 첫 운동으로 걷기 20분을 추천드려요. 신규 사용자분이라 처음부터 무리하지 않도록 가장 기본적인 저강도 운동인 걷기를 추천합니다. 오늘은 맑음에 다소 더운 편이지만 실외 운동 가능한 날씨이고, 저녁 시간에 20분간 편안하게 걸으며 운동 루틴을 시작하기에 좋습니다.', chatTime: time },
            { type: 'recommend', title: '🎯 김디팜님을 위한 운동 추천', desc: '오늘 하고 싶은 운동을 골라보세요.' },
            { type: 'chips', items: DIET_EXERCISE_CHIPS },
        ]);
        
    }, [mode]);

    useEffect(() => {
        chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [chatList]);

    const handleSend = () => {
        const message = textQuestion.trim();

        if (!message || isSending) return;

        // 애니메이션 시작
        setIsSending(true);

        // 실제 채팅 메시지 추가
        const time = getCurrentTime();

        setChatList(prev => [
            ...prev,
            {
                type: 'user',
                text: message,
                chatTime: time,
            }
        ]);

        // 입력창 초기화
        setTextQuestion('');

    };

    const renderItem = (chat, index) => {
        switch (chat.type) {
            case 'date':
                return (
                    <div key={index} className={style['hr-line']}>
                        <span>{chat.dateStr} 오늘</span>
                    </div>
                );
            case 'user':
                return (
                    <div key={index} className={style['user-talk-box']}>
                        <span className={style['date-txt']}>{chat.chatTime}</span>
                        <p>{chat.text}</p>
                    </div>
                );
            case 'bot':
                return (
                    <div key={index} className={style['ai-talk-box']}>
                        <strong className={style['ai-avatar']}>
                            <img src={imgAvata} alt="" />
                        </strong>
                        <div className={style['ai-box']}>
                            <div className={style['text-box']}>
                                <div className={style['p-group']}>
                                    <p style={{ whiteSpace: 'pre-line' }}>{chat.text}</p>
                                </div>
                                <span className={style['date-txt']}>{chat.chatTime}</span>
                            </div>
                        </div>
                    </div>
                );
            case 'recommend':
                return (
                    <div key={index} className={style['recommend-card']}>
                        <strong className={style['recommend-title']}>{chat.title}</strong>
                        {chat.name && <p className={style['recommend-name']}>{chat.name}</p>}
                        {chat.desc && <p className={style['recommend-desc']}>{chat.desc}</p>}
                    </div>
                );
            case 'action':
                return (
                    <div key={index} className={style['action-box']}>
                        <button className={style['action-btn']}>{chat.label}</button>
                    </div>
                );
            case 'feedback':
                return (
                    <div key={index} className={style['feedback-box']}>
                        <p className={style['feedback-q']}>{chat.question}</p>
                        <div className={style['feedback-opts']}>
                            {chat.options.map((opt, i) => (
                                <button key={i} className={style['feedback-btn']}>{opt}</button>
                            ))}
                        </div>
                    </div>
                );
            case 'chips':
                return (
                    <div key={index} className={style['chips-box']}>
                        {chat.items.map((c, i) => (
                            <button key={i} className={style['chip']}>{c}</button>
                        ))}
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <>
            <HeadSub title="챗봇" />
            <div id="sub-content" data-layout="blue">
                <div className="inner-wrap" data-pad-type="b">
                    {chatList.map(renderItem)}
                    <div ref={chatEndRef} />
                </div>


                {/* 추천 답변 칩 */}
                {showQuick && QUICK_REPLIES.length > 0 && (
                    <div
                        className={style['quick-reply-box']}
                        style={{
                            bottom: (isInputFocused && isAndroid)
                                ? 'calc(var(--sp-76) + env(keyboard-inset-height, 0px))'
                                : 'var(--sp-76)',
                        }}
                    >
                        <ul className={style['quick-reply-list']}>
                            {QUICK_REPLIES.map((text) => (
                                <li key={text}>
                                    <button
                                        type="button"
                                        className={style['quick-reply-chip']}
                                        onClick={() => handleQuickReply(text)}
                                    >
                                        {text}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <div className={style['bottom-fixed-box']}
                    style={{
                        bottom: (isInputFocused && isAndroid) ? 'env(keyboard-inset-height, 0px)' : '0px',
                    }}>
                        
                    <button className={style['attach-btn']}>
                        <img src={iconAttach} alt="첨부파일 추가버튼" />
                        <span className='blind'>첨부파일</span>
                    </button>    
                    
                    <div className={style['in-box']}>
                        <div className={style['input-box']}>
                            <input
                                ref={inputRef}
                                type="text"
                                placeholder="내용을 입력하세요"
                                value={textQuestion}
                                onChange={(e) => setTextQuestion(e.target.value)}
                                onFocus={() => setIsInputFocused(true)}
                                onBlur={() => setIsInputFocused(false)}
                            />
                        </div>
                    </div>
                    <button className={style['voice-btn']}>
                        <img src={iconVoice} alt="음성버튼" />
                        <span className='blind'>음성입력</span>
                    </button>    
                    <button 
                        className={`${style['push-btn']} ${isSending ? style['sending'] : ''}`}
                        disabled={!textQuestion.trim() || isSending}
                        onClick={handleSend}
                        onAnimationEnd={() => setIsSending(false)}
                        aria-label="보내기"
                    />
                </div>
            </div>
        </>
    );
};

export default ExerciseChatBot;